import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

/* ======================================================
   🔍 THUNK: SEARCH MERCHANTS (WITH ALL FILTERS)
====================================================== */
export const searchMerchantsThunk = createAsyncThunk(
  "merchantSearch/searchMerchants",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/search/search", {
        params: filters, // businessTypeId, businessCategoryId, query, page, limit...
      });

      return res.data; // full response
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error fetching merchants"
      );
    }
  }
);

/* ======================================================
   📍 THUNK: FETCH LOCAL AREAS BY DISTRICT NAME
====================================================== */
export const fetchLocalAreasByDistrictThunk = createAsyncThunk(
  "merchantSearch/fetchLocalAreasByDistrict",
  async (districtName, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/search/local-areas", {
        params: { districtName},
      });

      return res.data; // { success, district, count, data }
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error fetching local areas"
      );
    }
  }
);

/* ======================================================
   🔄 SLICE
====================================================== */
const merchantSearchSlice = createSlice({
  name: "merchantSearch",

  initialState: {
    results: null,     // merchants search result
    localAreas: [],    // local areas list
    loading: false,
    error: null,
  },

  reducers: {
    clearSearchResults: (state) => {
      state.results = null;
      state.error = null;
    },

    clearLocalAreas: (state) => {
      state.localAreas = [];
    },
  },

  extraReducers: (builder) => {
    builder
      /* ---------- SEARCH MERCHANTS ---------- */
      .addCase(searchMerchantsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchMerchantsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload;
      })
      .addCase(searchMerchantsThunk.rejected, (state, action) => {
        state.loading = false;
        state.results = null;
        state.error = action.payload;
      })

      /* ---------- FETCH LOCAL AREAS ---------- */
      .addCase(fetchLocalAreasByDistrictThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalAreasByDistrictThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.localAreas = action.payload?.data || [];
      })
      .addCase(fetchLocalAreasByDistrictThunk.rejected, (state, action) => {
        state.loading = false;
        state.localAreas = [];
        state.error = action.payload;
      });
  },
});

/* ======================================================
   EXPORTS
====================================================== */

// Actions
export const {
  clearSearchResults,
  clearLocalAreas,
} = merchantSearchSlice.actions;

// Reducer
export default merchantSearchSlice.reducer;
